import {
  PolymorphicComponentPropWithRef,
  PolymorphicRef,
} from "@kunduz/utility-polymorphic-component";
import classNames from "classnames";
import React from "react";
import styles from "./button.module.scss";

type ButtonSize = "sm" | "md" | "lg";
type ButtonColor = "blue" | "gray";
type ButtonTheme = "light" | "dark";

type ButtonProps<C extends React.ElementType> = PolymorphicComponentPropWithRef<
  C,
  {
    size?: ButtonSize | "lg";
    color?: ButtonColor | "gray";
    theme?: ButtonTheme | "light";
  }
>;

type ButtonComponent = <C extends React.ElementType = "button">(
  props: ButtonProps<C>,
) => React.ReactElement | null | any;

export const CloseButton: ButtonComponent = React.forwardRef(
  <C extends React.ElementType = "button">(
    { as, children, theme, size, color, ...rest }: ButtonProps<C>,
    ref?: PolymorphicRef<C>,
  ) => {
    const Component = as || "button";

    return (
      <Component
        ref={ref}
        {...rest}
        className={classNames(
          rest.className,
          styles.base,
          styles[`size-close-${size}`],
          styles[`variant-${theme}-${color}`],
        )}
      >
        {children}
      </Component>
    );
  },
);

//@ts-ignore
CloseButton.displayName = "Close Button";
